import React from "react"
import { Tooltip } from "./Styled"

export const AnalyticsTooltip =
    (node: any) => (
        <Tooltip>
            {`Période : `}
            <strong>
                {`${node.node.data.range.minMilliseconds}-${node.node.data.range.maxMilliseconds}ms`}
            </strong>
            <br />
            {`Nombre d'appels : `}
            <strong>
                {`${node.node.data.callIds.length}`}
            </strong>
            <br />
            {`Nombre d'événements : `}
            <strong>
                {`${node.node.data.eventCounter}`}
            </strong>
        </Tooltip>
    )